export default "__VITE_PUBLIC_ASSET__f78477f8__"